const localDateToUTC = (utcDate) => {
  const date = new Date(utcDate)
  const localDate = new Date(
    date.getTime() + date.getTimezoneOffset() * 60 * 1000
  )
  return localDate
}

export default localDateToUTC
